import type { Immutable } from "immer";
import React from "react";
import { ReactivatedFormWidget } from "tsi-common-react/src/forms/ReactivatedFormWidget/index";
import { t } from "ttag";

import { Context, templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { HomepageCTA } from "../HomepageCTA";
import { OrderProcessSteps } from "../OrderProcessSteps";
import { OrderSupportLayout } from "../OrderSupportLayout";

import styles from "./index.module.scss";

export const OrderLookupBody = (
    props: Immutable<
        Omit<templates.OrderLookupDocumentTemplate, "page_chrome">
    >,
): React.JSX.Element => {
    const chrome = React.useContext(Context).chrome;
    // Non-field errors land under __all__ (raised by clean() without a field).
    // Annotate as Record to allow __all__ key access (field-name keys are a
    // subset; widening via annotation avoids the no-unnecessary-type-assertion
    // lint rule that fires on `as` casts).
    const formErrors: Record<string, readonly string[] | undefined> | null =
        props.form.errors;
    const nonFieldErrors = formErrors?.["__all__"] ?? null;
    return (
        <>
            <OrderSupportLayout id="order-lookup" centered>
                <section className={styles.statusContainer}>
                    <h1>{t`Find your order`}</h1>
                    <p>{props.orders_header}</p>
                    <form method="post">
                        <CSRFToken />
                        {props.form.iterator.map((name) => {
                            const field = props.form.fields[name];
                            const errors = formErrors?.[name];
                            return (
                                <div key={name}>
                                    <div className="input-container">
                                        <ReactivatedFormWidget
                                            widget={field.widget}
                                        />
                                        <label htmlFor={field.widget.attrs.id}>
                                            {field.label}
                                        </label>
                                        {errors && errors.length > 0 && (
                                            <ul className="errorlist">
                                                {errors.map((error, i) => (
                                                    <li key={i}>{error}</li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                        {nonFieldErrors && nonFieldErrors.length > 0 && (
                            <ul className="errorlist nonfield">
                                {nonFieldErrors.map((error, i) => (
                                    <li key={i}>{error}</li>
                                ))}
                            </ul>
                        )}
                        <input
                            type="submit"
                            value={t`Look Up`}
                            id="look-up-btn"
                        />
                    </form>
                </section>
                <section className={styles.deliveryFlow}>
                    <div className={styles.iconsContainer}>
                        <h2>{t`Easy Ordering Process`}</h2>
                        <OrderProcessSteps staticBase={chrome.static_base} />
                    </div>
                </section>
            </OrderSupportLayout>
            <HomepageCTA mattressUrl={props.mattress_url} />
        </>
    );
};
